export enum GlaType {
  GLA ='GLA',
  NON_GLA = 'NON-GLA',
  NEGATIVE = 'NEGATIVE',
}
